import axiosApiClient from "../axios";

const PATH = '/api/room';
export const getAllRoomsByBranchId = async (branchId) => {
    try {
        return await axiosApiClient.get(`${PATH}/branch/${branchId}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get rooms by branch ID');
    }
};
